export default __webpack_public_path__ + "static/media/portrait-cropped.6ea1efe1.png";